import { useEffect, useRef, useState, forwardRef } from 'react';
import { Sprite, Container, Text } from "react-pixi-fiber";
import * as PIXI from "pixi.js";
import { GlowFilter } from '@pixi/filter-glow';
import { passTurnAudio } from "../../audio";

const glowFilter = new GlowFilter({
    distance: 15,
    outerStrength: 2,
    color: 0xffc107, // Example: golden color
    quality: 0.5,
});

const SurrenderButton = forwardRef(({ app, ready, scale, isPlayReady, onClick }, ref) => {

  const textRef = useRef(null)
  const [width, setWidth] = useState(null)
  const [height, setHeight] = useState(null)
  const passButtonRef = useRef(null)
  const whiteOverlayRef = useRef(null)


  function onPointerDown() {
      // console.log("onPointerDown")
      passButtonRef.current.scale.set(scale * 1.9)
  }

  function onPointerUp() {
      // console.log("onPointerUp")
      if (!isPlayReady) return
      passButtonRef.current.scale.set(scale * 2)
      passTurnAudio.play();
      onClick();
  }


  const onMouseOver = () => {
    // console.log("onMouseOver")
    console.log(ref)
    if (!ref.current.filters.includes(glowFilter)) ref.current.filters.push(glowFilter)
  }

  const onMouseOut = () => {
      // console.log("onMouseOut")
      ref.current.filters = ref.current.filters.filter(f => f !== glowFilter)
  }

  // useEffect(() => {
  //   if (app && websocketData.turn == websocketData.mySeat && isPlayReady && websocketData.round > 3 && !websocketData.winner) startBlinkingEffect()
  // }, [app, isPlayReady])

  useEffect(() => {
    if (app && ready && scale) {
      setWidth(PIXI.utils.TextureCache['wooden-button'].width * scale)
      setHeight(PIXI.utils.TextureCache['wooden-button'].height * scale)
      whiteOverlayRef.current = new PIXI.Graphics();
      whiteOverlayRef.current.beginFill(0xFFFFFF);
      whiteOverlayRef.current.drawRoundedRect(0, 0, PIXI.utils.TextureCache['wooden-button'].width * scale * 2, PIXI.utils.TextureCache['wooden-button'].height * scale * 2);
      whiteOverlayRef.current.endFill();
      whiteOverlayRef.current.alpha = 0;
      ref.current.addChild(whiteOverlayRef.current);
    }
  }, [app, ready, scale])

  useEffect(() => {
    
    if (app && ready && scale) {
      ref.current.interactive = true;
      ref.current.buttonMode = true;

      ref.current.filters = []
      ref.current.on('pointerdown', onPointerDown);
      ref.current.on('pointerup', onPointerUp);
      ref.current.on('pointerover', onMouseOver);
      ref.current.on('pointerout', onMouseOut);
    }
    return () => {
        if (ref && ref.current) {
            ref.current.off('pointerdown', onPointerDown);
            ref.current.off('pointerdown', onPointerUp);
            ref.current.off('pointerover', onMouseOver);
            ref.current.off('pointerout', onMouseOut);
        }
    };
  }, [app, ready, scale])

  return (
    <Container
      ref={ref}
      zIndex={2}
    >
      <Sprite 
        ref={passButtonRef}
        texture={PIXI.utils.TextureCache['wooden-button']}
        scale={scale * 2}
        // zIndex={2}
      />
      {
        ready &&
        <Text
          ref={textRef}
          x={width}
          y={height}
          text={'Surrender'}
          anchor={new PIXI.Point(0.5, 0.5)}
          style={
            new PIXI.TextStyle({
              fontFamily: 'Almendra',
              fontSize: app.screen.width / 70,
              fill: 'white',
              align: 'center'
            })
          }
        />
      }
    </Container>
  )
});

SurrenderButton.displayName = "SurrenderButton";

export default SurrenderButton;